import { Input } from 'semantic-ui-react';
import withKeyboard from './withKeyboard';

// Semantic UI Input with keyboard functionality
export default withKeyboard(Input);



// WEBPACK FOOTER //
// ./src/common/Components/Keyboard/KeyboardInput.js